import { useMutation } from '@tanstack/react-query';
import { updateChatParticipants } from '../../services/chats';

function useUpdateChatParticipants() {
  return useMutation({
    mutationFn: async (conversationId: string) => {
      const result = await updateChatParticipants(conversationId);
      return result;
    },
  });
}

export default useUpdateChatParticipants;
